import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader, SectionCard } from "@/components/common/Primitives";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Mail, MessageSquare, Bot } from "lucide-react";
import MicrosoftCard from "@/components/integrations/MicrosoftCard";

const INTEGRATIONS = [
  { key: "email", name: "E-Mail-Versand", icon: Mail, desc: "Versand über Microsoft Graph oder SMTP-Anbieter.", hint: "Benötigt Anbieter-Zugangsdaten. Bis dahin nur Entwürfe." },
  { key: "whatsapp", name: "WhatsApp Business", icon: MessageSquare, desc: "Offizielle WhatsApp Business Platform API.", hint: "Benötigt Business-Account, Telefonnummer-ID und Token. Keine inoffizielle Automatisierung." },
];

const STATUS = {
  not_configured: { label: "Nicht verbunden", cls: "bg-muted text-muted-foreground" },
  configured_pending: { label: "Hinterlegt · Prüfung ausstehend", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300" },
  connected: { label: "Verbunden", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300" },
};

export default function Integrations() {
  const { data } = useQuery({ queryKey: ["integrations"], queryFn: async () => (await api.get("/settings/integrations")).data });
  const { data: aiCfg } = useQuery({ queryKey: ["ai-config"], queryFn: async () => (await api.get("/ai/config")).data });
  const integ = data?.integrations || {};

  return (
    <div>
      <PageHeader title="Integrationen" description="Verbindungsstatus externer Dienste" />
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <MicrosoftCard />
        {INTEGRATIONS.map((it) => {
          const s = integ[it.key]?.status || "not_configured";
          const st = STATUS[s] || STATUS.not_configured;
          return (
            <SectionCard key={it.key} title={<span className="flex items-center gap-2"><it.icon className="h-4 w-4 text-muted-foreground" />{it.name}</span>}>
              <div className="flex flex-col gap-3">
                <Badge className={`w-fit ${st.cls}`} data-testid={`integration-status-${it.key}`}>{st.label}</Badge>
                <p className="text-sm text-muted-foreground">{it.desc}</p>
                <p className="text-xs text-muted-foreground">{it.hint}</p>
                <Button variant="outline" size="sm" disabled className="w-fit">Konfigurieren</Button>
              </div>
            </SectionCard>
          );
        })}
        <SectionCard title={<span className="flex items-center gap-2"><Bot className="h-4 w-4 text-muted-foreground" />Private KI</span>}>
          <div className="flex flex-col gap-3">
            <Badge className={`w-fit ${aiCfg?.ai?.endpoint ? STATUS.connected.cls : STATUS.not_configured.cls}`}>
              {aiCfg?.ai?.endpoint ? "Endpunkt hinterlegt" : "Nicht konfiguriert"}
            </Badge>
            <p className="text-sm text-muted-foreground">Lokaler Modell-Endpunkt (z. B. Ollama / vLLM). Keine Daten verlassen Ihre Umgebung.</p>
            <p className="text-xs text-muted-foreground">Konfiguration unter Einstellungen → KI.</p>
          </div>
        </SectionCard>
      </div>
    </div>
  );
}
